import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ListComponent } from '../list.component';
import { LeadFilter } from '../../models/lead.filter';
import { Quote } from '../../../shared/models/quote.interface';
import { LeadsDataSource } from '../../datasources/leads-data-source';

@Component({
  selector: 'app-list-desktop',
  templateUrl: './list-desktop.component.html',
  styleUrls: ['./list-desktop.component.scss']
})
export class ListDesktopComponent extends ListComponent implements OnInit {

  dataSource: LeadsDataSource;
  displayedColumns: string[] =
    ['projectName', 'projectNbr', 'customerName', 'jobType', 'probability', 'startDate', 'expirationDate', 'salesperson', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  errors: string;
  isRequesting: boolean;

  leads: Quote[];
  
  filter: LeadFilter = { jobTypeId: null, pastDue: false, salespersonId: '', projectName: '', dateRange: null, probability: '' } as LeadFilter;
  canAddLead: boolean = false;
  canAddQuote: boolean = false;
  canEditLead: boolean = false; 

  ngOnInit() {
    this.dataSource = new LeadsDataSource(this.leadService);
    this.loadLeads();

    super.init();
  }

  ngAfterViewInit(): void {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadLeads())
      )
      .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadLeads())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sort.sortChange.unsubscribe();
    this.paginator.page.unsubscribe();
  }

  loadLeads() {
    this.dataSource.loadLeads(this.filter, this.sort.active,
      this.sort.direction, this.paginator.pageIndex);
  }

  refreshSummary() {
    this.loadSummary();
    this.loadLeads();
  }
}
